import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15.2",
  height: "15.19",
  viewBox: "0 0 15.2 15.19"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.78,0,7.6,6.18,1.42,0,0,1.41,6.18,7.591,0,13.77l1.42,1.42L7.6,9.01l6.18,6.18,1.42-1.42L9.02,7.591,15.2,1.41Z",
  transform: "translate(0 0)",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}